import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  appendOutsideTaxForm,
  createOutsideTaxForm,
  forceAffirmativeValidation,
} from '@modules/business-accounts/forms/outside-tax/outside-tax.form';
import { IBaseFormBuilder } from '../../../builders/base-builder.class';
import { createAddressForm } from '../../../../address-form/address.form';
import { matchValidator } from '@utils/helpers/validators.helper';
import { forceValueValidator } from '../../../config-step/validators/force-value.validator';
import { SessionService } from '@domain/application/observable-services/session.service';
export class LegalPersonDataNonClientFormBuilder implements IBaseFormBuilder {
  private form: FormGroup;

  constructor(
    private readonly sessionService: SessionService,
    private config?: {
      useCompanyData?: boolean;
      isClient: boolean;
    }
  ) {
    this.form = new FormGroup({});
    // this.addTaxResidenceForm();
  }

  public build() {
    const { personType } = this.sessionService.getCommonInfoValue;
    if (personType == undefined) this.addTaxResidenceForm();
    this.addCompanyFields();
    this.addSectorFields();
    this.addAddressForm();
    this.form.addControl(
      'registrationNumber',
      new FormControl(null, [Validators.required, Validators.minLength(8), Validators.maxLength(8)])
    );
    this.form.addControl('areSectorAndSubsectorValid', new FormControl(null, [forceValueValidator(true)]));
    this.form.addControl('isSameAddressCompanyAndLegalRepresentant', new FormControl(false));
  }

  public getResult(): FormGroup {
    return this.form;
  }

  private addTaxResidenceForm(): this {
    appendOutsideTaxForm({
      to: this.form,
      with: createOutsideTaxForm({
        isTaxOutsideValidators: [forceAffirmativeValidation],
      }),
    });
    return this;
  }

  private addCompanyFields() {
    if (!this.config?.useCompanyData) return;
    this.form.addControl(
      'companyData',
      new FormGroup(
        {
          societyType: new FormControl(null, [Validators.required]),
          constitutionDate: new FormControl(null, [Validators.required]),
          ruc: new FormControl(null, [Validators.required]),
          businessName: new FormControl(null, [Validators.required]),
          email: new FormControl(null, [Validators.required, Validators.email]),
          confirmEmail: new FormControl(null, [Validators.required, Validators.email]),
        },
        matchValidator('email', 'confirmEmail')
      )
    );
  }

  private addSectorFields() {
    this.form.addControl(
      'sectorData',
      new FormGroup({
        sectorCode: new FormControl(null, [Validators.required]),
        subSectorCode: new FormControl(null, []),
      })
    );
  }

  private addAddressForm() {
    this.form.addControl('address', createAddressForm());
  }
}
